import React, { useEffect, useRef, useState } from "react";
import styles from "./WorkorderCustomers.module.css";
import engineer from "../../../assets/profile2.png";
import engineer2 from "../../../assets/man1.png";
import engineer3 from "../../../assets/woman1.png";
import engineer5 from "../../../assets/man2.png";
import engineer6 from "../../../assets/woman2.png";
import { List } from "antd";
import { SearchInput } from "../../../components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import dummyImg from "../../../assets/dummy.png";
import WorkOrderRequestMiddleware from "../../../store/Middlewares/WorkOrderRequestMiddleware";
import { IMG_URL } from "../../../store/Apis";

function WorkorderCustomers() {
 
  const navigate = useNavigate();

  const dispatch = useDispatch()
    const WorkOrderRequestCustomers = useSelector(state => state.WorkOrderRequestReducer.WorkOrderRequestCustomers)
    const [search, setSearch] = useState('')
    const timeout = useRef(null);
    const {t , i18n} = useTranslation();


    useEffect(() => {
        getWorkOrderRequestCustomers();
        getLanguage();
      }, []);

      const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language)
        } catch (e) {
            console.log(e)
        }
      };
    
      const getWorkOrderRequestCustomers = () => {
        let data= {
          search: search,
        }        
        dispatch(WorkOrderRequestMiddleware.getWorkOrderRequestCustomers(data))
      }

      const onSearchWorkOrderRequestCustomers = (text) => {
        let data = {
          search: text,
        };
        setSearch(text);
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
          dispatch(WorkOrderRequestMiddleware.getWorkOrderRequestCustomers(data))
        }, 1000);
      };
  const options = [
    {
      id: 1,
      name: "Hope Fuentes",
      img: engineer,
    },
    {
      id: 2,
      name: "Jackson Bradshaw",
      img: engineer2,
    },
    {
      id: 3,
      name: "Yuri Berry",
      img: engineer3,
    },
    {
      id: 4,
      name: "Unity Butler",
      img: engineer2,
    },
    {
      id: 5,
      name: "Unity Butler",
      img: engineer5,
    },
    {
      id: 6,
      name: "Timothy Mooney",
      img: engineer6,
    },
  ];

  const renderItem = (item) => {
    return (
      <div
        className={styles.box_item}
        onClick={() =>
          navigate("/WorkOrderRequest/WorkOrderList", {
            state: item,
          })
        }
      >
        <img src={item?.profile_image ? IMG_URL + item?.profile_image : dummyImg} className={styles.image} />
        <div className={styles.heading_view}>
          <text className={styles.tab_heading}> {item?.name}</text>
          <text className={styles.text}>{t("Customer")}</text>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.heading}>{t("Customers")}</h1>

      <div className={styles.used_search_input}>
        <SearchInput
          placeholder={t("Search")}
          onChange={(e) => onSearchWorkOrderRequestCustomers(e.target.value)}
        />
      </div>

      <List
        style={{ width: "100%" }}
        grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={WorkOrderRequestCustomers}
        renderItem={renderItem}
      />
    </div>
  );
}

export default WorkorderCustomers;
